<div class="main-page consultas">
    <div class="container-fluid">
        <!-- LINHA TITULO + PESQUISA -->

        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])" data-title="Voltar"><i
                            class="fas fa-arrow-left"></i></a>
                    Consultar Pneu
                </h1>
            </div>
        </div>

        <!-- <mat-progress-bar mode="indeterminate" *ngIf="loader"></mat-progress-bar> -->

        <div *ngIf="pneu.data.length === 0 && !loader">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro at&eacute; o momento...</p>
            </div>
            <div class="row no-gutters mt-3">
                <a (click)="this.router.navigate(['/pneu/create'])" mat-button color="primary"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                    Criar um novo Pneu
                </a>
            </div>
        </div>

        <div class="row no-gutters mt-3" *ngIf="pneu.data.length > 0">
            <div class="mat-elevation table-content">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%" class="ml-2">
                     <mat-label>Filtrar por Nome</mat-label>
                     <input matInput autocomplete="off"
                     (keyup)="this.applyFilter($event)" style="text-transform: uppercase;" #input>
                   </mat-form-field>
           
                </div>         

                <!-- (matSortChange)="handleSort($event)" -->

                <table mat-table [dataSource]="pneu" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="numeroFogo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Número de Fogo
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.numeroFogo}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="marca">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Marca
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.marca }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Empresa/Filial/Divisão
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nome }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="posicao">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Posição do Pneus
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.posicao }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="placa">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Placa do Veículo
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.placa }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar"
                                *ngIf="this.permissionService.hasPermission('PNEU_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Editar">
                                <a (click)="this.router.navigate(['/pneu/edit/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="clone">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Duplicar"
                                *ngIf="this.permissionService.hasPermission('PNEU_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Duplicar">
                                <a (click)="this.router.navigate(['/pneu/clone/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/duplic.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Visualizar"
                                *ngIf="this.permissionService.hasPermission('PNEU_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Visualizar">
                                <a (click)="this.router.navigate(['/pneu/view/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/view.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="handleDelete(element)" class="btn btn-link"
                                *ngIf="this.permissionService.hasPermission('PNEU_DELECAO_FUNCIONALIDADE', this.permissions)" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                    <mat-paginator *ngIf="pneu.data.length" [pageSize]="this.page.size" (page)="handlePageChanged($event)"
                    [length]="this.page.totalElements" showFirstLastButtons></mat-paginator>
                </div>
        </div>
    </div>
</div>
